import React from 'react';
import { Box, Flex } from 'rebass';
import SideNav from 'components/SideNav';

/**
 * @typedef {{
 *     id: string;
 *     ref: HTMLElement;
 *     label: string;
 *     display: boolean;
 * }} Section
 */

/**
 * Layout with a side navigation.
 *
 * @param {React.ReactChildren} children
 * @param {Section[]} sections
 */
export function SideNavLayout({ children, sections }) {
    return (
        <Box mx={4} my={2}>
            <Flex flex="1 1 0%" justifyContent="space-between">
                <Box flex="0 0 auto">{children}</Box>
                <Box flex="0 0 auto">
                    <SideNav sections={sections} />
                </Box>
            </Flex>
        </Box>
    );
}
